import { render } from "./NavSidebar.vue?vue&type=template&id=6d5e3d91"
import script from "./NavSidebar.vue?vue&type=script&lang=js"
export * from "./NavSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__